<template>
  <div class="users-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t("user.macAddress") }}</span>
        <list-search
          v-if="importIds.length"
          @listSearchEvn="listSearchEvn"
          @clearSearch="listSearchEvn"
        />
      </div>
      <div class="right-part">
        <el-upload
          action="/api/1/users/add/device/batch"
          ref="upload"
          accept=".xlsx"
          :headers="{ Authorization: `Bearer ${this.$cookie.get('token')}` }"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :on-success="handleDeviceSuccess"
        >
          <button class="global-button-style">
            {{ $t("devices.dictionary.import") }}
          </button>
        </el-upload>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="">
        <div class="global-table-header">
          <div class="facilitys-table-header-left">
            <p>设备总数量：{{ total ? total : 0 }}</p>
            <p>未锁定数量：{{ unlockCount ? unlockCount : 0 }}</p>
            <p>锁定数量：{{ lockCount ? lockCount : 0 }}</p>
            <p>正在锁定数量：{{ lockIngCount ? lockIngCount : 0 }}</p>
          </div>
          <div v-if="selectData.length">
            <button class="global-button-style" @click="batchLock">
              {{ $t("user.lock") }}
            </button>
            <button class="global-button-style" @click="batchUnLock">
              {{ $t("user.unlock") }}
            </button>
            <button class="global-button-style" @click="batchUnBind">
              {{ $t("user.unbind") }}
            </button>
            <button class="global-button-style" @click="batchResetPsw">
              {{ $t("user.resetPsw") }}
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <FacilityTable
          :tableProps="tableProps"
          :tableData="tableData"
          :selectCtrl="true"
          @tableHandle="tableHandle"
          @tableSelectionChange="tableSelectionChange"
          @tableFilterChange="tableFilterChange"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
      />
    </el-card>
  </div>
</template>

<script>
import FacilityTable from "@/components/facilityTable";
import Pagination from "@/components/pagination";
import ListSearch from "@/components/listSearch";

export default {
  components: {
    FacilityTable,
    Pagination,
    ListSearch
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "id",
          label: "ID"
        },
        {
          prop: "users",
          label: this.$t("user.nickname")
        },
        {
          prop: "lock",
          label: this.$t("user.lockStatus")
        },
        {
          prop: "model",
          label: this.$t("user.model")
        },
        {
          prop: "macAddress",
          obj: true,
          label: this.$t("user.macAddress")
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          width: 200,
          btn: [this.$t("user.unbind"), this.$t("user.resetPsw")]
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      paramsList: { limit: 10000, offset: 0, sortBy: "lock", orderBy: "DESC" },
      selectData: [],
      importIds: [],
      lockCount: 0,
      unlockCount: 0,
      lockIngCount: 0
    };
  },
  methods: {
    getfacilitys() {
      this.$http
        .getfacilitys(this.paramsList)
        .then(res => {
          this.selectData = [];
          this.total = res.data.count;
          this.tableData = res.data.rows;
          this.lockCount = res.data.lockCount;
          this.lockIngCount = res.data.lockIngCount;
          this.unlockCount = res.data.unlockCount;
        })
        .catch(() => {});
    },

    beforeAvatarUpload(file) {
      let type = file.name.split(".").pop();

      const isXlsx = type === "xlsx";

      if (!isXlsx) {
        this.$message.error("文件只能是 xlsx 格式!");
      }

      return isXlsx;
    },
    async handleDeviceSuccess(res) {
      this.importIds = res.data;
      this.selectData = [];
      this.paramsList.id = { $in: this.importIds };
      this.paramsList.offset = 0;
      this.getfacilitys();
      this.$message({
        type: "success",
        message: "导入成功"
      });
    },

    facilityUntie(item) {
      const data = {
        deviceUniqueId: item.deviceUniqueId,
        mac: item.macAddress
      };
      this.$http
        .facilityUntie(data)
        .then(res => {
          this.getfacilitys();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.unlockSuccess")
          });
        })
        .catch(() => {});
    },

    listSearchEvn(val) {
      val
        ? (this.paramsList.macAddress = val)
        : delete this.paramsList.macAddress;
      this.paramsList.offset = 0;
      this.getfacilitys();
    },

    tableHandle(obj) {
      if (obj.type == this.$t("user.unbind")) {
        this.facilityUntie(obj.data.row);
      } else if (obj.type == this.$t("user.lock")) {
        this.facilityLock("lock", obj.data.row.id);
      } else if (obj.type == this.$t("user.unlock")) {
        this.facilityLock("unlock", obj.data.row.id);
      } else if (obj.type == this.$t("user.resetPsw")) {
        this.$http
          .resetMacPwd({
            id: obj.data.row.id,
            deviceUniqueId: obj.data.row.deviceUniqueId,
            mac: obj.data.row.macAddress
          })
          .then(() => {
            this.$message({
              type: "success",
              message: this.$t("alertMsg.modifySuccess")
            });
          })
          .catch(err => {
            this.$message({
              type: "success",
              message: err.response.data.message
            });
          });
      }
    },

    facilityLock(type, id) {
      this.$http
        .facilityLock({ type, id })
        .then(() => {
          this.getfacilitys();
          this.$message({
            type: "success",
            message: this.$t("alertMsg.modifySuccess")
          });
        })
        .catch(err => {
          this.$message({
            type: "success",
            message: err.response.data.message
          });
        });
    },

    pageNum(val) {
      this.paramsList.offset = (val - 1) * this.paramsList.limit;
      this.getfacilitys();
    },

    tableSelectionChange(data) {
      this.selectData = data;
    },

    tableFilterChange(data) {
      let arr = Object.values(data)[0];
      if (arr.length) {
        this.paramsList.lock = { $in: arr };
      } else {
        delete this.paramsList.lock;
      }
      this.paramsList.offset = 0;
      this.getfacilitys();
    },

    batchLock() {
      let ids = this.selectData.map(item => item.id);
      this.facilityBatchLock("lock", ids);
    },
    batchUnLock() {
      let ids = this.selectData.map(item => item.id);
      this.facilityBatchLock("unlock", ids);
    },
    batchUnBind() {
      let ids = this.selectData.map(item => item.id);
      this.facilityBatchUntie(ids);
    },
    batchResetPsw() {
      let ids = this.selectData.map(item => item.id);
      this.batchResetMacPwd(ids);
    },

    async facilityBatchLock(type, id) {
      try {
        await this.$http.facilityLock({ type, id });
        this.getfacilitys();
        this.selectData = [];
        this.$message({
          type: "success",
          message: this.$t("alertMsg.modifySuccess")
        });
      } catch (error) {
        this.$message({
          type: "success",
          message: error.response.data.message
        });
      }
    },
    async facilityBatchUntie(ids) {
      try {
        await this.$http.facilityBatchUntie({ ids });
        this.getfacilitys();
        this.selectData = [];
        this.$message({
          type: "success",
          message: this.$t("alertMsg.modifySuccess")
        });
      } catch (error) {
        this.$message({
          type: "success",
          message: error.response.data.message
        });
      }
    },

    async batchResetMacPwd(id) {
      try {
        await this.$http.resetMacPwd({ id });
        this.getfacilitys();
        this.selectData = [];
        this.$message({
          type: "success",
          message: this.$t("alertMsg.modifySuccess")
        });
      } catch (error) {
        this.$message({
          type: "success",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.users-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .right-part {
    display: flex;
    align-items: center;
  }
  .facilitys-table-header-left {
    display: flex;
    align-content: center;
    > p {
      margin-right: 20px;
    }
  }
}
</style>
